export const blockIconsEditorDragHandle = (
	<span className='material-symbols-outlined'>drag_handle</span>
);
